export default function Stats() {
  const stats = [
    { number: "1999", label: "HAPPY CUSTOMERS" },
    { number: "1721", label: "PROJECT DONE" },
    { number: "97", label: "AWARDS WIN" },
    { number: "1650", label: "EXPERT WORKERS" },
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-orange-50/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center group">
              <div className="text-5xl md:text-6xl font-bold text-orange-500 mb-2 group-hover:scale-110 transition-transform duration-300">
                {stat.number}
              </div>
              <div className="text-sm md:text-base text-gray-600 font-semibold tracking-wide">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
